let APP_DOMAIN_FORMANDO = 'https://formando.alphaeditora.com.br',
  FTP_URL = 'https://alphaplay.alphaconvites.com.br/videos/ALPHAE/publicacoes/',
  URL_EMAIL = 'https://mail.alphaultrapress.com.br',
  APP_DOMAIN_COMISSAO = 'https://areadoformando.alphaeditora.com.br',
  REQUEST_URL = 'https://gateway.alphaeditora.com.br/api/agencia',
  URL_MAPA = 'https://gateway.alphaeditora.com.br/api/mapavendas',
  API_UPLOAD_PERSONALIZADAS =
    'https://alphaplay.alphaconvites.com.br/videos/ALPHAE/personalizadas/upload.php',
  EMAIL_SUPORTE = 'agencia01@alphaeditora.com.br',
  URL_ALPHAE_GRAPHQL = 'https://gateway.alphaeditora.com.br/graphql',
  URL_PAGAMENTO = 'https://pagamento.alphaeditora.com.br/api/agencia-pagamento',
  URL_API_UPLOAD = 'https://upload.alphaconvites.com.br/api/upload';
// APP_DOMAIN_COMISSAO = "https://comissaoteste.alphaeditora.com.br",
// REQUEST_URL = "https://agenciateste.alphaeditora.com.br:25000/api",
// URL_MAPA = "https://mapavendasteste.alphaeditora.com.br:5122/api/mapavendas",
// URL_ALPHAE_GRAPHQL = "https://centaurigraphql.alphaultrapress.com.br/graphql";

if (process.env.NODE_ENV === 'development') {
  // REQUEST_URL = "http://localhost:6001/api/agencia";
  // URL_MAPA = "http://localhost:5124/api/mapavendas";
  // URL_PAGAMENTO = "http://localhost:8000/api/agencia-pagamento";
  // URL_PAGAMENTO = "http://alpha-pagamentos-php8.sa-east-1.elasticbeanstalk.com/api/agencia-pagamento";
  // URL_ALPHAE_GRAPHQL = "https://centauriapi.alphaeditora.com.br:4000/graphql";
  // EMAIL_SUPORTE = "vitor@alphaeditora.com.br";
}

export {
  REQUEST_URL,
  FTP_URL,
  APP_DOMAIN_COMISSAO,
  APP_DOMAIN_FORMANDO,
  URL_MAPA,
  URL_EMAIL,
  URL_ALPHAE_GRAPHQL,
  API_UPLOAD_PERSONALIZADAS,
  EMAIL_SUPORTE,
  URL_API_UPLOAD,
  URL_PAGAMENTO,
};



// WEBPACK FOOTER //
// ./src/config/urls.js